<template>
  <div class="w-100 h-100 m-0 position-relative" style="padding: 32px">
    <div class="row m-0 p-0 acry-page-title justify-content-center">ご注文</div>
    <div class="row m-0 w-100 info-area">
      <div class="d-flex justify-content-center m-0 p-0 w-100">
        <!-- 商品イメージ -->
        <div class="product-img" style="margin: 0px 16px">
          <!-- <img src="@/assets/acrypro/producttop.jpg"/> -->
        </div>

        <!-- 入稿欄 -->
        <div class="" style="width:330px;">
          <!-- 制作サイズ -->
          <div style="margin:0px 16px 16px 16px;">
            <div class="row m-0 w-100 acry-text-title" style="font-size: 15px;">制作サイズ</div>
            <div class="row m-0 w-100">
              <div
                class="d-flex acry-btn-primary-big draft-btn justify-content-center align-items-center c-pointer" @click="clickDraft(0)">
                <span class="m-4 acry-text-white size-text pe-none">S</span>
                <span class="m-4 pe-none" style="font-size: 13px;">W61×H100×D3(mm)</span>
              </div>
            </div>
            <div class="row m-0 w-100">
              <div
                class="d-flex acry-btn-primary-big draft-btn justify-content-center align-items-center c-pointer" @click="clickDraft(1)">
                <span class="m-4 acry-text-white size-text pe-none">M</span>
                <span class="m-4 pe-none" style="font-size: 13px">W92×H150×D3(mm)</span>
              </div>
            </div>
            <div class="row m-0 w-100">
              <div
                class="d-flex acry-btn-primary-big draft-btn justify-content-center align-items-center c-pointer" @click="clickDraft(2)">
                <span class="m-4 acry-text-white size-text pe-none">L</span>
                <span class="m-4 pe-none" style="font-size: 13px">W139×H225×D3(mm)</span>
              </div>
            </div>
          </div>

          <!-- シェアコード入稿 -->
          <div class="position-relative" style="padding: 16px 16px;" :class="{'feature-ui':this.$store.state.tutorial.isShowShareCode}">
            <div class="d-flex">
              <div class="row m-0 acry-text-title" style="font-size: 15px; padding-bottom: 9px;">ACRY PRO用コード</div>
              <img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-top:2px;" class="cursor-pointer" @click="clickShareHelp()" />
            </div>
            <div class="d-flex" style="position: relative;">
              <input type="text" v-model="shareCode" class="forminput acry-text-main" placeholder="半角英数字6文字以上" @keydown.enter="clickShareCode" />
              <button class="acry-btn-primary-normal acrybtn ms-3" @click="clickShareCode">決定</button>
            </div>

            <!-- チュートリアル用 -->
            <TutorialModal
              :visible="$store.state.tutorial.isShowShareCode"
              title="ACRY PRO用コード"
              arrowTop="142px"
              style="pointer-events: all; position: absolute; height:185px; top:-84px; left:-640px"
              @close="endTutorial()">
              <p class="text-start m-0 mt-2">ACRYアプリで作成されたACRY PRO用コードを入力してご注文いただけます。</p>
              <p class="text-start m-0">※契約済みアカウントのみご利用可能です。</p>
            </TutorialModal>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.isCanFirstTimeFree" class="m-0 p-0 d-flex flex-column align-items-center">
      <hr class="m-auto" width="867">
      <p class="fw-bold" style="margin-top:40px;">ACRY PROを知って頂けるようにアイテム完成までの流れを体験していただけます</p>
      <div class="text-start" style="margin-top:8px; margin-bottom:14px; font-size:13px;">
        <p class="m-0" style="">※作成時の機能制限あり</p>
        <p class="m-0" style="">※契約されている方は初回無料でお試しいただけます</p>
      </div>
      <button class="mx-0 acry-btn fw-bold" style="background-color: #595959; width: 400px; height: 54px; border-radius: 100px; font-size: 16px; margin-bottom: 40px;" @click="clickFirstTimeFree">
        初回無料お試しサービス
      </button>
    </div>

    <div v-if="this.$store.state.isSignature" class="m-0 p-0 d-flex flex-column align-items-center">
      <hr class="m-auto" width="867">
      <p class="fw-bold" style="margin-top:40px;">デザインを元に弊社でカットラインを作成いたします</p>
      <button class="mx-0 acry-btn fw-bold" style="width: 400px; height: 54px; border-radius: 100px; font-size: 16px; margin-bottom: 40px;" @click="clickBehalfCreate">
        カットライン作成代行はこちら
      </button>
    </div>

    <hr class="m-auto" width="867">

    <div class="row m-0 w-100" style="padding:40px;">
      <div class="row pb-4">
        <p class="mb-0 pb-0 acry-text-title">入稿テンプレートダウンロード</p>
        <p class="mb-0 pb-0 acry-text-body">Adobe Illustrator バージョン CS 以上対応</p>
      </div>
      <div class="d-flex flex-column align-items-center">
        <div class="d-flex m-1 acry-btn-secondary-normal dl-btn justify-content-center align-items-center c-pointer" style="font-weight: bold; stroke-width:40px;" @click="clickDownloadBtn(0)">
          <div class="pe-none">S サイズ W61xH100xD3(mm)<i class="bi bi-download ms-2"></i></div>
        </div>
        <div class="d-flex m-1 acry-btn-secondary-normal dl-btn justify-content-center align-items-center c-pointer" style="font-weight: bold;" @click="clickDownloadBtn(1)">
          <div class="pe-none">M サイズ W92xH150xD3(mm)<i class="bi bi-download ms-2"></i></div>
        </div>
        <div class="d-flex m-1 acry-btn-secondary-normal dl-btn justify-content-center align-items-center c-pointer" style="font-weight: bold;" @click="clickDownloadBtn(2)">
          <div class="pe-none">L サイズ W139xH225xD3(mm)<i class="bi bi-download ms-2"></i></div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { CenterViewState, RightViewState, ProductId, GetCanvasSize } from "@/js/Const.js";
import { ResizeImageBlob } from "@/js/CommonFunc.js";
import { Analytics } from "@/js/Analytics.js";

// import Vue from "vue";
import config from "config";
import axios from "axios";
import JSZip from "jszip";
import VueCookies from "vue-cookies";
import firebase from "firebase/app";
import TutorialModal from "@/components/acyrpro/modal/TutorialModal.vue";

export default {
  name: "CenterViewUpload_Ap",
  props: {},
  data: function () {
    return {
      shareCode: "",
      isCanFirstTimeFree: false,
    };
  },
  computed: {},
  async created() {
    this.$store.commit('designPreview/reset');
    this.$store.commit('designPreview/set', { key: 'isShowUploadImage', value: true })


    this.$store.commit("hideRightMenu");
    this.$store.commit("setDesignImageURL", null);
    this.$store.commit("setCutlineImageURL", null);
    this.$store.commit("setScCutlineImageURL", null);
    this.$store.commit("setFrameCutlineImageURL", null);
    this.$store.commit("setDesignImageFile", null);
    this.$store.commit("setCutlineImageFile", null);
    this.$store.commit("setScCutlineImageFile", null);
    this.$store.commit("setFrameCutlineImageFile", null);
    this.$store.commit("setIsShareCodeDraft", false);
    this.$store.commit("setSelectProductId", "");
    this.$store.commit("setSelectBackgroundColor", 1);
    this.$store.commit("setSelectCutlineColor", 2);

    // 初回無料キャンペーンの状態を取得
    const FirstTimeFreeData = await this.$store.state.campaignManager.getFirstTimeFreeData();
    if( !FirstTimeFreeData ){
      this.isCanFirstTimeFree = true;
    }

    let isTutorial = VueCookies.get("t_s");
    if( !isTutorial ){
      VueCookies.set("t_s", true, '1y');

      // チュートリアル開始
      this.$store.commit("showShareCodeTutorial");
    }
  },
  components: { TutorialModal },
  methods: {
    clickDraft(index) {
      switch (index) {
        case 0:
          Analytics.createButtonClick('S', false);
          this.$store.commit("setSelectProductId", ProductId.S_SVG);
          break;
        case 1:
          Analytics.createButtonClick('M', false);
          this.$store.commit("setSelectProductId", ProductId.M_SVG);
          break;
        case 2:
          Analytics.createButtonClick('L', false);
          this.$store.commit("setSelectProductId", ProductId.L_SVG);
          break;
        default:
          this.$store.commit("setSelectProductId", 0);
          break;
      }
      // プレビュー用のデータを設定
      this.$store.commit('designPreview/set', { key: 'selectProductId', value: this.$store.state.selectProductId })

      this.$store.commit("setCenterViewState", CenterViewState.Preview);
      this.$store.commit('setRightViewState', RightViewState.Preview);
    },

    async clickShareCode() {
      if (!this.shareCode) {
        return;
      }

      // シェアコードの小文字を大文字にする
      this.$store.commit("showLoading")
      const designData = await this.getDesignData(this.shareCode);

      if (designData == null || designData.length == 0) {
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "存在しないコードです");
        return;
      }

      // プロダクトIDをチェック
      if (
        !["FreeAcrylic1", "FreeAcrylic2", "FreeAcrylic3"].includes(designData.productId)
      ) {
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "対象外の商品種別");
        return;
      }

      // 有効期限チェック
      var expireDate = new Date(designData.expireDate.iso);
      var nowDate = new Date();
      if( nowDate > expireDate ){
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "有効期限を過ぎています");
        return;
      }

      // デザインデータのダウンロード
      const url = config.s3DesignFilePath + designData.file;
      const zipData = await this.downloadZipFile(url);
      const blob = new Blob([zipData], { type: "application/zip" });
      const file = new File([blob], "", {});

      const zipdata = await new Promise((resolve) => {
        JSZip.loadAsync(file).then((res) => {
          resolve(res);
        });
      });

      switch (designData.productId) {
        case "FreeAcrylic1":
          Analytics.designCodeInput(this.shareCode, 'S', false);
          this.$store.commit("setSelectProductId", ProductId.L_SHARE);
          break;
        case "FreeAcrylic2":
          Analytics.designCodeInput(this.shareCode, 'M', false);
          this.$store.commit("setSelectProductId", ProductId.M_SHARE);
          break;
        case "FreeAcrylic3":
          Analytics.designCodeInput(this.shareCode, 'L', false);
          this.$store.commit("setSelectProductId", ProductId.S_SHARE);
          break;
      }

      // const design_cutlineBlob = await zipdata.file("forcartimage1.png").async("blob");
      const designBlob = await zipdata.file("forcartimage2.png").async("blob");
      const cutlineBlob = await zipdata.file("forcartimage3.png").async("blob");
      // const monoBlob = await zipdata.file("forcartimage4.png").async("blob");

      // const design_cutline = new File([design_cutlineBlob], "design_cutine.png", {
      //   type: "image/png",
      // });
      let design = new File([designBlob], "design.png", { type: "image/png" });
      let cutline = new File([cutlineBlob], "cutine.png", { type: "image/png" });
      // const mono = new File([monoBlob], "mono.png", { type: "image/png" });

      // アクリルに合わせるためにリサイズを行う
      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      design = await ResizeImageBlob(design, canvasSize.width, canvasSize.height);
      cutline = await ResizeImageBlob(cutline, canvasSize.width, canvasSize.height);

      // プレビュー用の画像を保存
      this.$store.commit('designPreview/set', { key: 'selectProductId', value: this.$store.state.selectProductId })
      this.$store.commit('designPreview/set', { key: 'designImageURL', value: URL.createObjectURL(design) })
      this.$store.commit('designPreview/set', { key: 'cutlineImagePngURL', value: URL.createObjectURL(cutline) });

      // データを保存
      this.$store.commit("setDesignImageURL", URL.createObjectURL(design));
      this.$store.commit("setScCutlineImageURL", URL.createObjectURL(cutline));
      this.$store.commit("setDesignImageFile", design);
      this.$store.commit("setScCutlineImageFile", cutline);
      this.$store.commit("setIsShareCodeDraft", true);
      this.$store.commit("setCenterViewState", CenterViewState.Preview);
      this.$store.commit('setRightViewState', RightViewState.Preview);
    },

    getDesignData() {
      return new Promise((resolve) => {
        const ref = firebase.firestore().collection("ShareInfo");
        ref.where("key", "==", this.shareCode).get().then((snapshot)=>
        {
          const data = snapshot.docs[0].data();
          resolve(data)
        }).catch(()=>
        {
          console.log("error");
          resolve([]);
        });
      });
    },

    async downloadZipFile(url) {
      return new Promise((resolve) => {
        axios
          .get(url, {
            responseType: "arraybuffer",
            headers: { Accept: "application/zip" },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            resolve();
          });
      });
    },

    clickDownloadBtn(index){
      Analytics.designTemplateDownload(['S', 'M', 'L'][index]);
      const files = ['ACRYPRO_regulationS.zip', 'ACRYPRO_regulationM.zip', 'ACRYPRO_regulationL.zip'];
      let link = document.createElement("a");
      link.href = 'template/' + files[index];
      link.download = files[index];
      link.click();
    },
    clickShareHelp(){
      this.$store.commit("showShareCodeTutorial");
    },
    endTutorial(){
      this.$store.commit("hideShareCodeTutorial");
    },

    async clickBehalfCreate(){
      this.$store.commit("showLoading");

      const history = await firebase.firestore().collection("AcryProBehalfCreateHistory")
      .where("uid", "==", firebase.auth().currentUser.uid)
      .orderBy("createAt", "desc")
      .get().then((snapshot)=>
        {
          if( snapshot.docs ){
            return snapshot.docs[0].data();
          }else{
            return null;
          }
        }).catch((e)=>
        {
          console.log(e);
        });

      if( history ){
        const date = history.createAt.toDate();
        const now = new Date();
        if( now.getTime() - date.getTime() < 86400000 ){
          this.$store.commit("showMessage", 
          "本日分は依頼済みです\n\n大変申し訳ございません、前回の依頼から24時間空けて再度依頼の程よろしくお願いいたします。\n\n前回依頼日時："+this.formatDate(date));
          this.$store.commit("hideLoading");
          return;
        }
      }

      this.$store.commit("setCenterViewState", CenterViewState.BehalfCreate);
      this.$store.commit("setRightViewState", RightViewState.Cart);
      this.$store.commit("hideLoading");
    },

    async clickFirstTimeFree(){
      this.$store.commit("showLoading");

      // 契約状況をチェック
      if (!this.$store.state.isSignature) {
        this.$store.commit("showResendContractDialog");
        //this.$store.commit("showMessage", "契約書へのサインが完了していません");
        return;
      }

      // 作成済かチェック

      // const history = await firebase.firestore().collection("AcryProBehalfCreateHistory")
      // .where("uid", "==", firebase.auth().currentUser.uid)
      // .orderBy("createAt", "desc")
      // .get().then((snapshot)=>
      //   {
      //     if( snapshot.docs ){
      //       return snapshot.docs[0].data();
      //     }else{
      //       return null;
      //     }
      //   }).catch((e)=>
      //   {
      //     console.log(e);
      //   });

      // if( history ){
      //   const date = history.createAt.toDate();
      //   const now = new Date();
      //   if( now.getTime() - date.getTime() < 86400000 ){
      //     this.$store.commit("showMessage", 
      //     "本日分は依頼済みです\n\n大変申し訳ございません、前回の依頼から24時間空けて再度依頼の程よろしくお願いいたします。\n\n前回依頼日時："+this.formatDate(date));
      //     this.$store.commit("hideLoading");
      //     return;
      //   }
      // }

      this.$store.commit("setCenterViewState", CenterViewState.FirstTimeFreeTop);
      this.$store.commit("setRightViewState", RightViewState.Cart);
      this.$store.commit("hideLoading");
    },
    formatDate(date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.info-area{
  padding: 40px 0px;
  justify-content: center;
  /* border-radius: 15px;
  font-size: 15px;
  border: 0px; */
}
.product-img {
  width: 534px;
  height: 356px;
  border-radius: 20px;
  background: url("~@/assets/acrypro/producttop.jpg");
  background-size: cover;
}
.draft-btn {
  height: 55px;
  width: 100%;
  margin-top: 16px;
}
.dl-btn {
  height: 42px;
  width: 400px;
}
.size-text {
  font-size: 28px;
  font-weight: bold;
}

.acrybtn{
  position: absolute;
  right: 7px;
  top: 5px;
  height: 40px;
  width: 106px;
}
.forminput {
  border-radius: 100px;
  height:50px;
  width: 300px;
  padding-left: 16px;
  border: 0;
  border-bottom: 1px solid $border-sub-color;
  background: $background-purplegray-color;
}
.templateletter{
  letter-spacing: 0.25em;
}
.feature-ui{
  z-index: 5;
  pointer-events: none;
  background: white;
}
</style>
